{
  "pagesProject": "illustrator-to-figma",
  "devUi": [
    "http://localhost:5174",
    "http://localhost:8788"
  ],
  "variants": [
    {
      "key": "illustrator-to-figma",
      "id": "1675139964504328568",
      "name": "illustrator.tomake.design",
      "ui": "https://illustrator.plugin.tomake.design",
      "subtitle": "Import .ai artwork as editable layers or images",
      "accept": ".ai,.eps,.ps,.xps,.oxps",
      "dropHint": "Drop an .ai or .eps to begin",
      "brand": "illustrator.tomake.design",
      "formats": "Illustrator (.ai), EPS (.eps), PostScript (.ps) and XPS (.xps)"
    }
  ],
  "retiredIds": {
    "1675139847663932791": "illustrator-to-figma"
  }
}
